module.exports = __webpack_public_path__ + "statics/img/ycz2m.bfa1d23c.png";